module.exports = __webpack_public_path__ + "img/iMediaMatrix.8d8f942e.png";